// Ported from Cards.vue to fix loader issue, and improve code quality/layout

import router from "@/core/router";
import {
  InstanceType,
  INSTANCE_STATION,
  INSTANCE_OWNERSHIP_ENTITY,
  INSTANCE_CLUSTER,
  INSTANCE_COMPANY,
  ProductInstanceResult,
  AdminUserResult
} from "@futuri/cloudsso-client";
import { getInstanceHierarchyInstanceId } from "@futuri/cloudsso-client/src/instanceUtils";
import { SessionModuleState } from ".";

export const currentProduct = (_state: SessionModuleState): InstanceType => {
  return router.currentRoute?.params?.productType;
};

export const filteredCardInstances = async (
  _state: SessionModuleState,
  { rootGetters, getters }: { rootGetters: any; getters: any }
): Promise<ProductInstanceResult[]> => {
  const { currentProduct, currentClusterInstanceId } = getters;
  const { availableInstances } = rootGetters;

  // const availableInstances = this.availableInstances ?? [];
  // const currentProduct = this.productType;

  const productInstances = availableInstances.filter(
    (inst: ProductInstanceResult) => inst.product === currentProduct
  );
  const stationInstances = productInstances.filter(
    (inst: ProductInstanceResult) => inst.instanceType === INSTANCE_STATION
  );
  // Match based on name because that's what fm-cluster-switcher currently contains
  // const selectedInstance = availableInstances?.filter(inst => inst.name === this.selectedCluster)[0]
  // const currentClusterInstanceId = this.currentClusterInstanceId;
  const includeAll =
    !currentClusterInstanceId?.length ||
    currentClusterInstanceId === "all" ||
    currentClusterInstanceId === "(All Clusters)";

  const matching = stationInstances?.filter((inst: ProductInstanceResult) =>
    includeAll
      ? true
      : inst.instanceType === INSTANCE_STATION &&
        (getInstanceHierarchyInstanceId(inst, INSTANCE_OWNERSHIP_ENTITY) ===
          currentClusterInstanceId ||
          getInstanceHierarchyInstanceId(inst, INSTANCE_CLUSTER) ===
            currentClusterInstanceId ||
          getInstanceHierarchyInstanceId(inst, INSTANCE_COMPANY) ===
            currentClusterInstanceId)
  );

  return matching;
};
